import styled from "@emotion/styled/macro";
import {
  Banner,
  BannerTypes,
  Typography,
} from "@sunrun/experience-ui-components";
import { ListOffer } from "../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  NewOfferCard,
  OfferCard,
} from "components/molecules/OfferCard/OfferCard";
import { LinkButton } from "checkout/components/atoms/LinkButton";

const OfferList = ({
  onAddNewOffer,
  offers,
  disableAddNewOffer,
  hideAddNewOffer,
  onLoading,
  setError,
  isAtClosedAndWon,
  isSRM,
}: {
  onAddNewOffer: () => void;
  isAtClosedAndWon?: boolean;
  isSRM?: boolean;
  offers: ListOffer[];
  disableAddNewOffer?: boolean;
  hideAddNewOffer?: boolean;
  onLoading: (message: string | undefined) => void;
  setError: React.Dispatch<React.SetStateAction<Error | undefined>>;
}) => {
  const showBanner = isAtClosedAndWon && isSRM;
  return (
    <>
      <OfferListTitle>
        {offers.length} Offer{offers.length > 1 ? "s" : ""}
      </OfferListTitle>
      <StyledBanner
        bannerType={BannerTypes.InfoLight}
        show={showBanner}
        showClose={false}
        bannerTestId="post-close-won-banner"
      >
        <RowContainer>
          <div>
            <Typography fontWeight="medium">
              This customer already has an approved offer
            </Typography>
            <Typography>
              New offers need to be created from approved designs by the design
              engineering team through the change order process. Designs that
              aren't approved risk failing permit and or inspection. Please
              search Current for instructions, try contacting SSD, or use the
              CAP changes needed button.
            </Typography>
          </div>
          <StyledLinkButton
            data-testid="post-close-won-current-link"
            href="https://current.sunrun.com/site/7b6848bd-8bfb-5e2e-b56d-41b94260487d/content?type=page&pageCategoryId=5daf3824-a623-53e2-a6e8-06a6ec0120a0"
            target="_blank"
          >
            Go to Current
          </StyledLinkButton>
        </RowContainer>
      </StyledBanner>
      <OffersContainer>
        {offers.map((offer) => {
          return (
            <OfferCard
              key={offer.id}
              offer={offer}
              onLoading={onLoading}
              setError={setError}
            />
          );
        })}
        {!hideAddNewOffer && (
          <NewOfferCard
            disableAddNewOffer={disableAddNewOffer}
            onAddNewOffer={onAddNewOffer}
          />
        )}
      </OffersContainer>
    </>
  );
};

const OfferListTitle = styled.div`
  font-size: 20px;
  line-height: 24px;
`;

const OffersContainer = styled.div`
  display: flex;
  padding: 20px 0;
  gap: 16px;
  overflow-x: scroll;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

const StyledLinkButton = styled(LinkButton)`
  text-wrap: nowrap;
  text-wrap-mode: nowrap;
`;

const StyledBanner = styled(Banner)`
  margin-top: 17px;
  margin-bottom: 19px;
  margin-left: 0;
  max-width: fit-content;
`;

export { OfferList };
